// extracted by mini-css-extract-plugin
export default {"fossaSelect":"FOnENQ6O7a3V3zJzSoXM","smoothLeft":"IkZWlayCojkjGp0qUlTE","smoothRight":"RAiTt28FqtDwo0rjB3cR"};